async function serial_writeCommand(writer, text) {
    await writer.write(text)
    await writer.write('\r')
}

async function serial_readResponse(reader) {
    let response = '';

    while (!response.endsWith('\r')) {
        let data = await reader.read();
        
        if (data.value !== undefined) {
            response += data.value;
        }

        if (data.done === true) {
            break;
        }
    }
    
    // Trim the trailing newline
    response = response.slice(0, response.length - 1);

    return response.split(',');
}

async function serial_readWrite(reader, writer, command) {
    await serial_writeCommand(writer, command);
    let response = await serial_readResponse(reader);
    // var baseCommand = command.split(',')[0];
    // if (response[0] != baseCommand) {
    //     throw new Error(`Command response mismatch: Expected ${baseCommand} but was ${response[0]}.`);
    // }

    // return response.slice(1);

    return response;
}

async function serial_close() {
    await this.reader.cancel();
    await this.inputDone.catch(() => {});

    await this.writer.close();
    await this.outputDone;

    await this.port.close();
}

async function serial_connectPort(port, baudRate) {
    await port.open({ baudRate: 9600, dataBits:8, stopBits: 1, parity: `none`, flowControl: `none` });

    // eslint-disable-next-line no-undef
    const decoder = new TextDecoderStream();
    const inputDone = port.readable.pipeTo(decoder.writable);
    const inputStream = decoder.readable;

    const reader = inputStream.getReader();

    // eslint-disable-next-line no-undef
    const encoder = new TextEncoderStream();
    const outputDone = encoder.readable.pipeTo(port.writable);
    const outputStream = encoder.writable;

    const writer = outputStream.getWriter();

    return {
        port: port,
        reader: reader,
        writer: writer,

        write: serial_writeCommand.bind(undefined, writer),
        read: serial_readResponse.bind(undefined, reader),
        send: serial_readWrite.bind(undefined, reader, writer),
        close: serial_close,

        inputDone: inputDone,
        outputDone: outputDone,
        outputStream: outputStream,
    }
}

export {
    serial_connectPort,
    serial_close,
    serial_readResponse,
    serial_readWrite,
    serial_writeCommand,
}